import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getCIQTokenRequest } from "src/store/actions/creditIQ";
import { hasCreditIQ } from "src/store/selectors/creditIQ";
import { getDealUUID } from "src/store/selectors/deal";
import useSelector from "src/utils/useSelector";

const useFetchCiqToken = (vin: string = ""): boolean => {
    const dispatch = useDispatch();

    const uuid = useSelector(getDealUUID);

    const hasCreditIQIntegration = useSelector((state) => hasCreditIQ(state, vin));

    const needsToken = useSelector((state) => state?.creditIQ?.tokenBundle?.[vin] === undefined);

    // We'll always fetch the token to keep it fresh, but only set the loading state true if we don't already have one
    const [fetchingToken, setFetchingToken] = useState<boolean>(hasCreditIQIntegration && needsToken);

    useEffect(() => {
        if (hasCreditIQIntegration && uuid && vin) {
            dispatch(getCIQTokenRequest(uuid, vin, () => setFetchingToken(false)));
        }
    }, [vin]);

    return fetchingToken;
};

export default useFetchCiqToken;
